export const generateNewNameMultiLanguage = (
  nameTemplate: string,
  values: Array<Record<string, any>>,
  defaultLanguage: string,
  nameField: string = "name",
  caseInSensitive?: boolean
) => {
  if (
    values.every((x) =>
      caseInSensitive ? x[defaultLanguage][nameField].toLowerCase() !== nameTemplate.toLowerCase() : x[defaultLanguage][nameField] !== nameTemplate
    )
  ) {
    return nameTemplate;
  }

  const pattern = new RegExp((caseInSensitive ? nameTemplate.toLowerCase() : nameTemplate) + " \\((?<counter>\\d+)\\)");
  const counters = values
    .map((x) => pattern.exec(caseInSensitive ? x[defaultLanguage][nameField].toLowerCase() : x[defaultLanguage][nameField])?.groups?.counter)
    .filter((x) => x)
    .map((x) => parseInt(x ?? "-1"))
    .sort((a, b) => a - b);
  const nextCounter = counters.length ? counters[counters.length - 1] + 1 : 1;
  return `${nameTemplate} (${nextCounter})`;
};

export const generateNewName = (nameTemplate: string, values: Array<Record<string, any>>, nameField: string = "name", caseInSensitive?: boolean) => {
  if (values.every((x) => (caseInSensitive ? x[nameField].toLowerCase() !== nameTemplate.toLowerCase() : x[nameField] !== nameTemplate))) {
    return nameTemplate;
  }

  const pattern = new RegExp((caseInSensitive ? nameTemplate.toLowerCase() : nameTemplate) + " \\((?<counter>\\d+)\\)");
  const counters = values
    .map((x) => pattern.exec(caseInSensitive ? x[nameField].toLowerCase() : x[nameField])?.groups?.counter)
    .filter((x) => x)
    .map((x) => parseInt(x ?? "-1"))
    .sort((a, b) => a - b);
  const nextCounter = counters.length ? counters[counters.length - 1] + 1 : 1;
  return `${nameTemplate} (${nextCounter})`;
};
